<div class="pager-wrapper" *ngIf="!isMobile">
	<!--<pre>{{frameMotion$ | async | json}}</pre>-->
	<div *ngIf="page == 1" [@NextStep]="{ value: '', params: frameMotion$ | async }">
		<div class="page-content" [style.align-items]="pages > 1 ? 'stretch' : 'center'">
			<ng-content select=".page-1"></ng-content>
		</div>
	</div>
	<div *ngIf="page == 2" [@NextStep]="{ value: '', params: frameMotion$ | async }">
		<div class="page-content" [style.align-items]="pages > 1 ? 'stretch' : 'center'">
			<ng-content select=".page-2"></ng-content>
		</div>
	</div>
	<div *ngIf="page == 3" [@NextStep]="{ value: '', params: frameMotion$ | async }">
		<div class="page-content" [style.align-items]="pages > 1 ? 'stretch' : 'center'">
			<ng-content select=".page-3"></ng-content>
		</div>
	</div>
	<div *ngIf="page == 4" [@NextStep]="{ value: '', params: frameMotion$ | async }">
		<div class="page-content" [style.align-items]="pages > 1 ? 'stretch' : 'center'">
			<ng-content select=".page-4"></ng-content>
		</div>
	</div>
	<div class="paginator-container">
		<div class="paginator-button paginator-button__left" [style.top]="arrowPosition" (click)="leftPaginator()" *ngIf="hideLeftButton.value">
			<app-icon-button
				[hasShadow]="false"
				[onDarkShade]="true"
				(clickEvent)="leftPaginator()"
				[srcString]="'Chevron Left'"
				[size]="25"></app-icon-button>
		</div>
		<div *ngIf="pages > 1" class="paginator-wrapper">
			<div
				*ngFor="let $page of $pages"
				class="pager-page-selector"
				(click)="DotPagination($page)"
				[style.background-color]="page === $page ? '#FFF' : 'rgba(255,255,255,0.3)'"></div>
		</div>
		<!--    <div class="paginator-button paginator-button__right" [style.top]="arrowPosition" (click)="RightPaginator()"><img class="button-image" *ngIf="hideRightButton.value" [src]="'./assets/Chevron Right (White).svg' | resolveAsset"></div>-->
		<div class="paginator-button paginator-button__right" [style.top]="arrowPosition" *ngIf="hideRightButton.value">
			<app-icon-button
				[hasShadow]="false"
				[onDarkShade]="true"
				(clickEvent)="RightPaginator()"
				[srcString]="'Chevron Right'"
				[size]="25"></app-icon-button>
		</div>
	</div>
</div>

<div class="swiper" *ngIf="isMobile">
	<swiper [config]="config" [index]="page - 1" (indexChange)="onSlideChange($event)" (init)="swiperInit($event)">
		<ng-content select=".page-5"></ng-content>
		<ng-content select=".page-6"></ng-content>
		<ng-content select=".page-7"></ng-content>
		<ng-content select=".page-8"></ng-content>
	</swiper>
	<div class="dots-wrapper" [style.bottom]="'-16px'">
		<div class="paginator-container">
			<div *ngIf="pages > 1" class="paginator-wrapper">
				<div
					*ngFor="let $page of $pages"
					class="pager-page-selector"
					(click)="DotPagination($page)"
					[style.background-color]="page === $page ? '#FFF' : 'rgba(255,255,255,0.3)'"></div>
			</div>
		</div>
	</div>
</div>
